import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { FeatureFlagSettingInterface } from '../../store/callrecorder/featureFlagSettingsSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => ({
  ...value,
  url: callrecorderUrls.featureFlagPath(value.id)
});

export const featureFlagSettingsEntity = new schema.Entity('featureFlagSettings', {}, { processStrategy });
export const featureFlagSettingEntity  = new schema.Entity('featureFlagSetting',  {}, { processStrategy });

const normalizeCollection = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { featureFlagSettings: { [key: string]: FeatureFlagSettingInterface } }
  >(response.data.feature_flags, [featureFlagSettingsEntity]);

  return {
    featureFlagSettings: normalized.entities?.featureFlagSettings || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { featureFlagSetting: FeatureFlagSettingInterface }
  >(response.data.feature_flag, featureFlagSettingEntity);
  return normalized.entities;
}

export const fetchFeatureFlagSettings = createAsyncThunk(
  `${PREFIX}_featureFlagSettings/fetchFeatureFlagSettings`,
  async (params: object = {}) => {
    const response = await callrecorderApi.get('/onesky/feature_flags', { params });
    return normalizeCollection(response);
  }
);

export const fetchFeatureFlagSetting = createAsyncThunk(
  `${PREFIX}_featureFlagSettings/fetchFeatureFlagSetting`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/feature_flags/${id}`);
    return normalizeInstance(response);
  }
);

export const updateFeatureFlagSetting = createAsyncThunk(
  `${PREFIX}_featureFlagSettings/updateFeatureFlagSetting`,
  async (
    { id, data }: { id: number | string, data: object },
    { rejectWithValue }
  ) => {
    try {
      const response = await callrecorderApi.patch(`/onesky/feature_flags/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error);
    }
  }
);
